module.exports = __webpack_public_path__ + "media/subway/G-b15dca37.png";